function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("style", null, ".experience_svg__st0{fill:#1f386b}");

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "experience_svg__Layer_1-2"
}, React.createElement("path", {
  className: "experience_svg__st0",
  d: "M14.5 14c-.1 0-.2 0-.3-.1l-4.7-3.6V5.4c0-.3.2-.5.5-.5s.5.2.5.5v4.4l4.4 3.3c.2.2.3.5.1.7-.2.1-.3.2-.5.2z"
}), React.createElement("path", {
  className: "experience_svg__st0",
  d: "M10 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zm0-15c-3.9 0-7 3.1-7 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7z"
}), React.createElement("path", {
  className: "experience_svg__st0",
  d: "M10 20C4.5 20 0 15.5 0 10S4.5 0 10 0s10 4.5 10 10-4.5 10-10 10zm0-19c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9z"
}), React.createElement("circle", {
  className: "experience_svg__st0",
  cx: 10,
  cy: 10,
  r: 1
}), React.createElement("path", {
  className: "experience_svg__st0",
  d: "M9.5 2.5h1V4h-1zM9.5 16h1v1.5h-1zM16 9.5h1.5v1H16zM2.5 9.5H4v1H2.5z"
}));

var SvgExperience = function SvgExperience(props) {
  return React.createElement("svg", _extends({
    id: "experience_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20",
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyMCAyMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjAgMjA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojMUYzODZCO30KPC9zdHlsZT4KPHRpdGxlPkFzc2V0IDY8L3RpdGxlPgo8ZyBpZD0iTGF5ZXJfMS0yIj4KCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xNC41LDE0Yy0wLjEsMC0wLjIsMC0wLjMtMC4xbC00LjctMy42VjUuNGMwLTAuMywwLjItMC41LDAuNS0wLjVzMC41LDAuMiwwLjUsMC41djQuNGw0LjQsMy4zCgkJYzAuMiwwLjIsMC4zLDAuNSwwLjEsMC43QzE0LjgsMTMuOSwxNC43LDE0LDE0LjUsMTR6Ii8+Cgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTAsMThjLTQuNCwwLTgtMy42LTgtOHMzLjYtOCw4LThzOCwzLjYsOCw4UzE0LjQsMTgsMTAsMTh6IE0xMCwzYy0zLjksMC03LDMuMS03LDdzMy4xLDcsNyw3czctMy4xLDctNwoJCVMxMy45LDMsMTAsM3oiLz4KCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xMCwyMEM0LjUsMjAsMCwxNS41LDAsMTBTNC41LDAsMTAsMHMxMCw0LjUsMTAsMTBTMTUuNSwyMCwxMCwyMHogTTEwLDFjLTUsMC05LDQtOSw5czQsOSw5LDlzOS00LDktOQoJCVMxNSwxLDEwLDF6Ii8+Cgk8Y2lyY2xlIGNsYXNzPSJzdDAiIGN4PSIxMCIgY3k9IjEwIiByPSIxIi8+Cgk8cmVjdCB4PSI5LjUiIHk9IjIuNSIgY2xhc3M9InN0MCIgd2lkdGg9IjEiIGhlaWdodD0iMS41Ii8+Cgk8cmVjdCB4PSI5LjUiIHk9IjE2IiBjbGFzcz0ic3QwIiB3aWR0aD0iMSIgaGVpZ2h0PSIxLjUiLz4KCTxyZWN0IHg9IjE2IiB5PSI5LjUiIGNsYXNzPSJzdDAiIHdpZHRoPSIxLjUiIGhlaWdodD0iMSIvPgoJPHJlY3QgeD0iMi41IiB5PSI5LjUiIGNsYXNzPSJzdDAiIHdpZHRoPSIxLjUiIGhlaWdodD0iMSIvPgo8L2c+Cjwvc3ZnPgo=";
export { SvgExperience as ReactComponent };